import { cur } from '@/lib/currency';
import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import api from '@/lib/api';
import { toast } from 'sonner';

const EMPTY = { from_branch_id: '', to_branch_id: '', amount: '', payment_mode: 'cash' };

export const BranchPaybackDialog = ({ open, onOpenChange, branches = [], onSuccess }) => {
  const [data, setData] = useState(EMPTY);
  const submit = async () => {
    if (!data.from_branch_id || !data.to_branch_id || !data.amount) { toast.error('Fill all fields'); return; }
    try {
      await api.post('/branch-paybacks', { ...data, amount: parseFloat(data.amount), date: new Date().toISOString() });
      toast.success('Payback recorded - dues updated');
      onOpenChange(false);
      setData(EMPTY);
      onSuccess?.();
    } catch (err) { toast.error(err.response?.data?.detail || 'Failed'); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="payback-dialog">
        <DialogHeader><DialogTitle className="font-outfit">Record Branch Payback</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground mb-3">When one branch pays back another branch for expenses paid on their behalf</p>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label>Paying Branch (who owes)</Label>
              <Select value={data.from_branch_id || 'none'} onValueChange={(v) => setData({ ...data, from_branch_id: v === 'none' ? '' : v })}>
                <SelectTrigger data-testid="payback-from-branch"><SelectValue placeholder="Select" /></SelectTrigger>
                <SelectContent>{branches.map(b => <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div>
              <Label>Receiving Branch (who paid)</Label>
              <Select value={data.to_branch_id || 'none'} onValueChange={(v) => setData({ ...data, to_branch_id: v === 'none' ? '' : v })}>
                <SelectTrigger data-testid="payback-to-branch"><SelectValue placeholder="Select" /></SelectTrigger>
                <SelectContent>{branches.map(b => <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div>
              <Label>Amount *</Label>
              <Input type="number" step="0.01" value={data.amount} onChange={(e) => setData({ ...data, amount: e.target.value })} placeholder="SR 0.00" data-testid="payback-amount" />
            </div>
            <div>
              <Label>Mode</Label>
              <Select value={data.payment_mode} onValueChange={(v) => setData({ ...data, payment_mode: v })}>
                <SelectTrigger data-testid="payback-mode"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="cash">Cash</SelectItem>
                  <SelectItem value="bank">Bank</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <Button className="rounded-xl w-full" onClick={submit} data-testid="payback-submit">Record Payback</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
